import { useServices } from '../../hooks/ServiceHooks';
import { WP_Service } from '../../model/models';
import { ModelsService } from '../../services/ModelsService';
import { Modal } from '../globals/Modal';
import { SanitizeHTML } from '../globals/SanitizeHTML';
import InvoiceList from '../services/invoice/InvoiceList';
import { ServiceContent } from '../services/serviceContent/ServiceContent';
import { IconSize, ServiceIcon } from '../services/ServiceIcon';

const ServicesResults = ({ items }) => {
  const baseUrl = '/search';

  const { services } = useServices();

  const itemRenderer = (service: WP_Service, baseUrl, index) => {
    const slugs = ModelsService.getServiceFullSlug(service);

    const url = slugs.includes('emergency') ? '/emergency' : baseUrl + slugs;

    const isInvoices = slugs.includes('invoices');

    return (
      <li key={index} className="relative w-full" style={{ height: '60px' }}>
        <Modal
          content={
            <div className="md:bg-white md:rounded-3xl md:p-5 h-full md:h-auto">
              {isInvoices && <InvoiceList service={service} />}
              {!isInvoices && (
                <ServiceContent services={services} service={service} />
              )}
            </div>
          }
          ModalUrl={url}
          backUrl={baseUrl}
        >
          <div
            className="inline-flex items-center justify-end w-16 h-16 pl-24 pr-0.5 pt-2 pb-3 absolute left-0 top-0 bg-green-400 rounded-lg"
            style={{ backgroundColor: service.acf.color }}
          >
            <div className="flex-1 text-center relative -left-4 z-50">
              {service.acf.icon && (
                <ServiceIcon
                  className="relative rounded-full"
                  service={service}
                  size={IconSize.medium}
                />
              )}
            </div>
          </div>
          <div
            className="inline-flex flex-col space-y-1 text-center items-center justify-start h-16 py-1.5 pl-9 pr-10 absolute right-0 top-0 left-16 bg-white border rounded-lg"
            style={{ borderColor: service.acf.color }}
          >
            <SanitizeHTML
              tag="p"
              html={service.title.rendered}
              className="text-base font-medium leading-none line-clamp-2"
            />
            {service.acf.subtitle ? (
              <SanitizeHTML
                tag="p"
                html={service.acf.subtitle}
                className="opacity-50 w-full text-xs leading-none truncate"
              />
            ) : (
              ''
            )}
          </div>
        </Modal>
      </li>
    );
  };

  return (
    <ul className="ion-list-events grid lg:grid-cols-2 2xl:grid-cols-3 gap-4 xl:gap-8">
      {items.map((service, index) => itemRenderer(service, baseUrl, index))}
    </ul>
  );
};

export default ServicesResults;
